var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"page-loading"},[_c('img',{attrs:{"src":require("@/assets/tangimg/20220720113958.gif"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }